// Debe coincidir con la lista de isAdmin() en firestore.rules.
export const ADMIN_EMAILS = ["juli.dapur@gmail.com"];

export const isAdminUser = (user) =>
  !!user?.email && ADMIN_EMAILS.includes(user.email);
